// @flow
import React from 'react';
import './DepartmentsNavListSkeleton.css';

const SKELETON_WIDTHS = [90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90];

const DepartmentsNavListSkeleton = () => (
  <div className="dept-nav-skeleton-wrapper">
    {SKELETON_WIDTHS.map((width, i) => (
      <div
        key={i}
        className="dept-nav-skeleton-item skeleton-block"
        style={{ width }}
      />
    ))}
  </div>
);

export default DepartmentsNavListSkeleton;
